import { render, staticRenderFns } from "./BioQAView.vue?vue&type=template&id=51ffd2ea&scoped=true&"
import script from "./BioQAView.vue?vue&type=script&lang=js&"
export * from "./BioQAView.vue?vue&type=script&lang=js&"
import style0 from "./BioQAView.vue?vue&type=style&index=0&id=51ffd2ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ffd2ea",
  null
  
)

export default component.exports